import { Select } from '@/components/Select'

interface Option { id: string; name: string | null }

/**
 * Searchable dropdown for long lists (projects, firms). Same control as every other form
 * select: type to filter, chevron next to the label, bottom sheet on the phone.
 */
export function SearchSelect({
  value, onChange, options, allLabel, placeholder, theme = 'dark',
}: {
  value: string
  onChange: (v: string) => void
  options: Option[]
  allLabel: string
  placeholder: string
  theme?: 'dark' | 'light'
}) {
  return (
    <Select
      value={value}
      onChange={onChange}
      options={options.map((o) => ({ value: o.id, label: o.name ?? '' }))}
      empty={{ value: '', label: allLabel }}
      placeholder={placeholder}
      tone={theme}
    />
  )
}
